'use client';

import { Controller } from 'react-hook-form';
import { AmountCheckbox } from '@/shared/ui/amount-checkbox';
import { FormFieldProps } from './types';
import { mergeRefs } from './utils/mergeRefs';
import { parseRulesForInputAttributes } from './utils/parseRulesForInputAttributes';

// A checkbox's controlled value is a boolean, but the DOM `defaultValue` inherited from
// the underlying input narrows it to string | number. Re-widen it to what the Controller
// actually stores, so callers can seed an explicit `false`.
type Props = Omit<FormFieldProps<typeof AmountCheckbox>, 'defaultValue'> & {
    defaultValue?: boolean;
};
export const FormAmountCheckbox = ({
    id,
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    ref,
    disableCheck,
    disableUncheck,
    ...props
}: Props) => {
    return (
        <Controller
            {...{ name, control, defaultValue, disabled, rules, shouldUnregister }}
            render={({ field: { ref: fieldRef, value, onChange, ...field } }) => {
                return (
                    <AmountCheckbox
                        ref={mergeRefs([fieldRef, ref])}
                        id={id || name}
                        checked={value === true || Number(value) > 0}
                        onCheckedChange={(next) => onChange(next === true)}
                        {...parseRulesForInputAttributes(rules)}
                        {...field}
                        disableCheck={disableCheck}
                        disableUncheck={disableUncheck}
                        {...props}
                    />
                );
            }}
        />
    );
};
